import type { ProspectResponse } from '@common/types/prospects';
import { Box, Grid, Typography } from '@mui/material';
import CurrencyInput from '@/components/CurrencyInput';
import { formatCurrency } from '@/utils';

interface Props {
    prospect: ProspectResponse;
    handleValueChange: (name: string, value: any) => void;
}

export default function SalePricingBreakdown({ prospect, handleValueChange }: Props) {
    const { prospectSummary } = prospect;
    const isAlberta = prospect.quoteTemplate?.province === 'Alberta';
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={6} lg={6}>
                        <CurrencyInput
                            label="Legal fee"
                            fullWidth
                            allowDecimal
                            name="legalFee"
                            value={prospectSummary.legalFee || 0}
                            onChange={(value: string | number) =>
                                handleValueChange('legalFee', value)
                            }
                        />
                    </Grid>
                    <Grid item xs={6} lg={6}>
                        <CurrencyInput
                            label="Discount on Legal Fee"
                            fullWidth
                            allowDecimal
                            name="legalFeeDiscount"
                            value={prospectSummary.legalFeeDiscount}
                            onChange={(value) => handleValueChange('legalFeeDiscount', value)}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6} lg={6}>
                        <CurrencyInput
                            label={`Net legal fee with ${isAlberta ? 'GST' : 'HST'}`}
                            fullWidth
                            allowDecimal
                            disabled
                            name="legalFeeWithHst"
                            value={prospectSummary.legalFeeWithHst || 0}
                            onChange={(value: string | number) =>
                                handleValueChange('legalFeeWithHst', value)
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={6} lg={6}>
                        <CurrencyInput
                            label="Disbursements"
                            fullWidth
                            allowDecimal
                            name="estimatedDisbursements"
                            value={prospectSummary.estimatedDisbursements || 0}
                            onChange={(value) => handleValueChange('estimatedDisbursements', value)}
                        />
                    </Grid>
                    <Grid item xs={6} lg={6}>
                        <CurrencyInput
                            label={`Disbursements with ${isAlberta ? 'GST' : 'HST'}`}
                            fullWidth
                            disabled
                            allowDecimal
                            name="disbursementWithHst"
                            value={prospectSummary.disbursementWithHst || 0}
                            onChange={(value) => handleValueChange('disbursementWithHst', value)}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={6} lg={4}>
                    <CurrencyInput
                        label="Registration fees"
                        fullWidth
                        allowDecimal
                        name="estimatedRegistrationFees"
                        value={prospectSummary.estimatedRegistrationFees || 0}
                        onChange={(value) => handleValueChange('estimatedRegistrationFees', value)}
                    />
                </Grid>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h3">Quote total</Typography>
                <Typography variant="h3">${formatCurrency(prospect?.quoteTotal || 0)}</Typography>
            </Box>
        </>
    );
}
